import React from "react";
import { Link, useNavigation } from "@react-navigation/native";
import {
    DataTable,
    LoadingScreen,
    StyleFunction,
    Surface,
    Text,
    useThemedStyle,
} from "@venuepos/react-common";
import { usePrinterWithRelationsLazyQuery } from "graphql-sdk";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AdminContainer } from "../..";

export function PrinterProductsScreen({ id }: { id: string }) {
    const printerId = id;

    const { navigate } = useNavigation();
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);

    const [getPrinter, printer] = usePrinterWithRelationsLazyQuery({
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        if (!printerId) {
            navigate("PRINTERS");
            return;
        }

        getPrinter({ variables: { id: printerId } });
    }, [getPrinter, navigate, printerId]);

    if (!printer.data || !printer.data.printer) {
        return <LoadingScreen style="light" />;
    }

    if (printer.data.printer.product.length === 0) {
        return (
            <AdminContainer>
                <Surface style={styles.surfaceContainer}>
                    <Text>
                        {t(
                            "backoffice.printer.no_products",
                            "No products use this printer"
                        )}
                    </Text>
                </Surface>
            </AdminContainer>
        );
    }

    return (
        <AdminContainer>
            <Surface style={styles.surfaceContainer}>
                <Text>
                    {t(
                        "backoffice.printer.product_description",
                        "These products are using the printer {{name}}",
                        { name: printer.data.printer.name }
                    )}
                </Text>

                <DataTable>
                    {printer.data.printer.product.map((product, _index) => (
                        <DataTable.Row key={product.id}>
                            <DataTable.Cell style={styles.checkboxCell}>
                                <Link
                                    to={{
                                        screen: "PRODUCT_EDIT",
                                        params: { id: product.id },
                                    }}
                                    style={styles.textLink}
                                >
                                    {product.name}
                                </Link>
                            </DataTable.Cell>
                        </DataTable.Row>
                    ))}
                </DataTable>
            </Surface>
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        width: "100%",
        backgroundColor: theme.colors.white,
    },
    surfaceContainer: {
        marginVertical: theme.spacingScale / 2,
    },
    textLink: {
        ...theme.styles.link,
    },
});
